import { Link } from "react-router-dom/cjs/react-router-dom.min"

const Prueba = () => {
    return (
        
        <Link to= "/login"> Ingresar</Link>
    )
  }
  
  export default Prueba